<template>
  <q-modal
      :value="opened"
      @close="close()"
      @escape-key="close()"
      @hide="close()"
  >
    <h1
      class="q-pt-lg q-px-sm q-pb-sm"
    >
      Новый статус для проекта
    </h1>

    <div class="q-px-md q-pb-md">
      <div
          v-for="(description, lockStatus) in lockStatuses"
          class="q-pa-sm"
      >
        <q-radio
            v-model="newStatus"
            :label="description"
            :val="lockStatus"
        />
      </div>

      <div class="row justify-end q-mt-md">
        <q-btn
            @click="lockProject()"
            color="primary"
            flat
            class="q-ml-sm"
            label="Применить"
        />

        <q-btn
            @click="close()"
            color="primary"
            flat
            class="q-ml-sm"
            label="Отмена"
        />
      </div>
    </div>
  </q-modal>
</template>

<script>
import {
  QBtn,
  QModal,
  QRadio,
} from 'quasar';

import projectLockStatuses from "../../mixins/projectLockStatuses";

export default {
  name: "ProjectLockStatusModal",

  props: {
    project: {
      type: Object,
      required: true,
    },

    opened: {
      type: Boolean,
      default: false,
    }
  },

  components: {
    QBtn,
    QModal,
    QRadio,
  },

  mixins: [
    projectLockStatuses,
  ],

  data() {
    return{
      newStatus: '',
    }
  },

  methods: {
    lockProject() {
      if(this.newStatus){
        this.$store.dispatch('project/lockProject', {
          project: this.project,
          newStatus: this.newStatus,
        }).then(() => {
          this.close();
        });
      }
    },

    close() {
      this.$emit('closed')
    },
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/ProjectLockStatus/ProjectLockStatusModal.vue